(function() {
  const SECOND_IN_MS = 1000;
  const HOUR_IN_SECONDS = 3600;
  const DAY_IN_SECONDS = 86400;

  // Store intervals for cleanup
  const intervals = new WeakMap();

  function format(value) {
    return ('0' + parseInt(value)).slice(-2);
  }

  function calculateTime(remaining) {
    if (remaining <= 0) {
      return { days: '00', hours: '00', minutes: '00', seconds: '00' };
    }

    const days = remaining / DAY_IN_SECONDS;
    const daysRemaining = remaining % DAY_IN_SECONDS;
    const hours = daysRemaining / HOUR_IN_SECONDS;
    const hoursRemaining = daysRemaining % HOUR_IN_SECONDS;
    const minutes = hoursRemaining / 60;
    const minutesRemaining = hoursRemaining % 60;
    const seconds = minutesRemaining;

    return {
      days: format(days),
      hours: format(hours),
      minutes: format(minutes),
      seconds: format(seconds),
    };
  }

  function getRemaining(config) {
    const now = Date.now();

    if (config.timeFormat === 'fixed' && config.endTimeFixed) {
      return parseInt((config.endTimeFixed.getTime() - now) / SECOND_IN_MS);
    }

    if (config.timeFormat === 'daily' && config.endTimeDaily) {
      const [hours, minutes, seconds] = config.endTimeDaily.split(':').map(Number);
      const endDateDaily = new Date();
      endDateDaily.setHours(hours, minutes, seconds, 0);
      let remaining = parseInt((endDateDaily.getTime() - now) / SECOND_IN_MS);

      if (remaining <= 0) {
        endDateDaily.setDate(endDateDaily.getDate() + 1);
        remaining = parseInt((endDateDaily.getTime() - now) / SECOND_IN_MS);
      }

      return remaining;
    }

    return 0;
  }

  function updateDisplay(el, time) {
    const daysEl = el.querySelector('[data-days]');
    const hoursEl = el.querySelector('[data-hours]');
    const minutesEl = el.querySelector('[data-minutes]');
    const secondsEl = el.querySelector('[data-seconds]');

    if (daysEl) daysEl.textContent = time.days;
    if (hoursEl) hoursEl.textContent = time.hours;
    if (minutesEl) minutesEl.textContent = time.minutes;
    if (secondsEl) secondsEl.textContent = time.seconds;
  }

  function destroyCountdown(el) {
    if (!el) return;
    const intervalId = intervals.get(el);
    if (intervalId) {
      clearInterval(intervalId);
      intervals.delete(el);
    }
    delete el.dataset.initialized;
  }

  function initCountdown(el) {
    if (!el) return;
    
    // Clear any existing interval
    destroyCountdown(el);

    const config = {
      timeFormat: el.dataset.timeFormat || 'fixed',
      endTimeFixed: el.dataset.endTimeFixed ? new Date(el.dataset.endTimeFixed.replace(' ', 'T')) : null,
      endTimeDaily: el.dataset.endTimeDaily || '23:59:59',
    };

    el.dataset.initialized = 'true';

    function tick() {
      const remaining = getRemaining(config);
      const time = calculateTime(remaining);
      updateDisplay(el, time);
    }

    // Initial update
    tick();

    // Start interval and store reference
    const intervalId = setInterval(tick, SECOND_IN_MS);
    intervals.set(el, intervalId);
  }

  function initAllCountdowns() {
    document.querySelectorAll('.ctr-countdown').forEach(initCountdown);
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllCountdowns);
  } else {
    initAllCountdowns();
  }

  // Handle Shopify theme editor events
  document.addEventListener('shopify:section:load', function(e) {
    const countdowns = e.target.querySelectorAll('.ctr-countdown');
    countdowns.forEach(initCountdown);
  });

  document.addEventListener('shopify:section:unload', function(e) {
    const countdowns = e.target.querySelectorAll('.ctr-countdown');
    countdowns.forEach(destroyCountdown);
  });

  // Handle block select/deselect for live preview updates
  document.addEventListener('shopify:block:select', function(e) {
    const countdown = e.target.querySelector('.ctr-countdown') || e.target.closest('.ctr-countdown');
    if (countdown) initCountdown(countdown);
  });
})();
